import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';

import { useAppSelector } from '~/hooks/store';
import { selectTheme } from '~/store/preferences/selectors';

import { themeSettings } from './helpers';

export function ThemeWrapper(props: PropsWithChildren) {
  const mode = useAppSelector(selectTheme);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  );
}
